/**
 * Presentational button component for downloading data.
 */

export default function DownloadButton({
  onClick,
}: {
  onClick: () => void;
}): JSX.Element {
  return (
    <button
      onClick={onClick}
      className="btn mx-1 hover:bg-gray-100 hidden md:block"
      data-cy="download-button"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-download"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="#9e9e9e"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
        <polyline points="7 11 12 16 17 11" />
        <line x1="12" y1="4" x2="12" y2="16" />
      </svg>
    </button>
  );
}
